import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Link from 'flarum/common/components/Link';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
import PostLikesModalState from '../states/PostLikesModalState';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Form from 'flarum/common/components/Form';
export default class PostLikesModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.state = new PostLikesModalState({
      filter: {
        liked: this.attrs.post.id()
      }
    });
    this.state.refresh();
  }
  className() {
    return 'PostLikesModal Modal--small';
  }
  title() {
    return app.translator.trans('flarum-likes.forum.post_likes.title');
  }
  content() {
    return m('[', null, m("div", {
      className: "Modal-body"
    }, this.state.isInitialLoading() ? m(LoadingIndicator, null) : m("ul", {
      className: "PostLikesModal-list"
    }, this.state.getPages().map(page => page.items.map(user => m("li", null, m(Link, {
      href: app.route.user(user)
    }, m(Avatar, {
      user: user
    }), " ", username(user))))))), this.state.hasNext() ? m("div", {
      className: "Modal-footer"
    }, m(Form, {
      className: "Form--centered"
    }, m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--block",
      onclick: () => this.state.loadNext(),
      loading: this.state.isLoadingNext()
    }, app.translator.trans('flarum-likes.forum.post_likes.load_more_button'))))) : null);
  }
}
flarum.reg.add('flarum-likes', 'forum/components/PostLikesModal', PostLikesModal);